import { SET_AUTH_DATA, LOG_OUT_USER, IS_LOADING, SET_LAYOUT, TOGGLE_SIDE_BAR, TOGGLE_SEARCH, TOGGLE_LOCALE, TOGGLE_DARK_MODE, TOGGLE_MENU_STYLE, TOGGLE_LAYOUT_STYLE, SET_AUTH_DATA_IN_STATE, SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD } from './types/root/mutations-types';
import i18n from '../i18n';
import { setAuthDataInLocalStorage, clearSessionData,clearLogoutData, isUserDataExist, getUserData } from "../utils/local_storage"
import router from '@/router';
import { updateRoutesBasedOnUserRole } from '@/router/dynamic-route';
export default {
    
        [SET_LAYOUT]:(state, payload) =>{
            state.layout = payload;
        },

        [TOGGLE_SIDE_BAR]: (state, value) =>{
            state.is_show_sidebar = value;
        },

        [TOGGLE_SEARCH]: (state, value)=> {
            state.is_show_search = value;
        },

        [TOGGLE_LOCALE]: (state, value) =>{
            value = value || 'en';
            i18n.global.locale = value;
            localStorage.setItem('i18n_locale', value);
            state.locale = value;
        },
        [TOGGLE_DARK_MODE]: (state, value)=> {
            //light|dark|system
            value = value || 'light';
            localStorage.setItem('dark_mode', value);
            state.dark_mode = value;
            if (value == 'light') {
                state.is_dark_mode = false;
            } else if (value == 'dark') {
                state.is_dark_mode = true;
            } else if (value == 'system') {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector('body').classList.add('dark');
            } else {
                document.querySelector('body').classList.remove('dark');
            }
        },

        [TOGGLE_MENU_STYLE]: (state, value) =>{
            //horizontal|vertical|collapsible-vertical
            value = value || '';
            localStorage.setItem('menu_style', value);
            state.menu_style = value;
            if (!value || value === 'vertical') {
                state.is_show_sidebar = true;
            } else if (value === 'collapsible-vertical') {
                state.is_show_sidebar = false;
            }
        },

        [TOGGLE_LAYOUT_STYLE]: (state, value)=> {
            //boxed-layout|large-boxed-layout|full
            value = value || '';
            localStorage.setItem('layout_style', value);
            state.layout_style = value;
        },
        [SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD]: (state, value)=>{
            state.auth.is_authenticated = true
        },
        [SET_AUTH_DATA]: (state, value)=> {
            state.auth.user = value;
            state.auth.is_authenticated = true
            state.auth.user_type = value.group.toLowerCase()
            updateRoutesBasedOnUserRole(router, value.group.toLowerCase())
            setAuthDataInLocalStorage({IdToken: value.token, userType: value.group.toLowerCase(), userId: value.id})
        },
        [LOG_OUT_USER]: (state, value)=> {
            // clearSessionData()
            clearLogoutData()
            state.auth.is_authenticated = value
        },
        [IS_LOADING]: (state, value)=> {
            state.isLoading = value
        },
        [SET_AUTH_DATA_IN_STATE]: (state, value)=>{
            localStorage.setItem("auth_data", JSON.stringify(value))
            state.auth_data.username = value.username
            state.auth_data.password = value.password ? value.password : ''
            if(value.temp_password)
                state.auth_data.temp_password = value.temp_password
        },
    
}
